/* eslint-disable no-console */

import {register} from 'register-service-worker'

const APP_VERSION = '2';
const savedVersion = localStorage.getItem('app_version');

if (savedVersion !== APP_VERSION) {
  localStorage.setItem('app_version', APP_VERSION);
  console.log('[App] Version changed → forcing hard refresh');
  window.location.reload(true);
}

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registered () {
      console.log('Service worker has been registered.')
    },
    cached () {
      console.log('Content has been cached for offline use.')
    },
    updatefound () {
      console.log('New content is downloading.')
    },
    updated () {
      console.log('New content is available; please refresh.')
      document.location.reload()
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })
}
